import React, { useState, useEffect } from 'react'
import { message, Form } from 'antd'
import { useMutation } from '@apollo/client'
import LoyaltyBonusForm from './LoyaltyBonusForm'
import { CREATE_LOYALTY_BONUS, UPDATE_LOYALTY_BONUS } from './LoyaltyQueries'
import { uuid } from 'uuidv4'
import { StyledDrawer, wideOrderDrawerStyles } from 'components/Common'
import styled from '@emotion/styled'

const { useForm } = Form
const LoyaltyBonusFormDrawer = (props: any) => {
  const {
    stores,
    loyaltyCards,
    merchant,
    drawerVisible,
    closeFormDrawer,
    refetch,
    loyaltyBonus
  } = props

  const [insertLoyaltyBonus] = useMutation(CREATE_LOYALTY_BONUS)
  const [updateLoyaltyBonus] = useMutation(UPDATE_LOYALTY_BONUS)
  const [submitDisabled, setSubmitDisabled] = useState(false)

  useEffect(() => {
    if (loyaltyBonus) {
      form.setFieldsValue({
        ...loyaltyBonus,
        loyalty_card_id: loyaltyBonus?.loyalty_card?.id,
        store_id: loyaltyBonus?.store?.id
      })
    } else {
      form.resetFields()
    }
  }, [loyaltyBonus?.id])

  const createLoyaltyBonus = (values: any) => {
    message.loading('Creating loyalty bonus. Please wait...')
    setSubmitDisabled(true)
    insertLoyaltyBonus({
      variables: { ...values, id: uuid(), merchant_id: merchant?.id }
    })
      .then(() => {
        message.destroy()
        message.success('Successfully created loyalty bonus!', 3)
        refetch()
        closeFormDrawer()
        form.resetFields()
        setSubmitDisabled(false)
      })
      .catch((error) => {
        console.error(error)
        message.destroy()
        message.error(
          'Unable to create loyalty bonus. Please contact support@slerp.com',
          3
        )
        setSubmitDisabled(false)
      })
  }

  const updateBonus = (values: any) => {
    message.loading('Updating loyalty bonus. Please wait...')
    setSubmitDisabled(true)
    updateLoyaltyBonus({
      variables: { ...values, id: loyaltyBonus?.id }
    })
      .then(() => {
        message.destroy()
        message.success('Successfully updated loyalty bonus!', 3)
        refetch()
        closeFormDrawer()
        form.resetFields()
        setSubmitDisabled(false)
      })
      .catch((error) => {
        console.error(error)
        message.destroy()
        message.error(
          'Unable to update loyalty bonus. Please contact support@slerp.com',
          3
        )
        setSubmitDisabled(false)
      })
  }

  const drawerTitle = loyaltyBonus ? 'Edit Loyalty Bonus' : 'Add Loyalty Bonus'

  const [form] = useForm()
  return (
    <StyledLoyaltyBonusDrawer
      open={drawerVisible}
      onClose={() => {
        closeFormDrawer()
      }}
      width={720}
      destroyOnClose={true}
      footer={null}
      colorScheme='light'
      title={drawerTitle}
    >
      <LoyaltyBonusForm
        closeFormDrawer={closeFormDrawer}
        createBonus={createLoyaltyBonus}
        updateBonus={updateBonus}
        stores={stores}
        loyaltyCards={loyaltyCards}
        submitDisabled={submitDisabled}
        bonus={loyaltyBonus}
        form={form}
      />
    </StyledLoyaltyBonusDrawer>
  )
}

const StyledLoyaltyBonusDrawer = styled(StyledDrawer)`
  ${wideOrderDrawerStyles}

  .ant-drawer-body {
    margin-top: -24px;
    padding: 0;
  }

  > * > * > * > .ant-drawer-header-no-title {
    min-height: 54px;
  }
`

export default LoyaltyBonusFormDrawer
